export enum DealFormType {
  main = "main",
  lost = "lost",
}
